import { MdOutlineError } from 'react-icons/md';
import { CarGroundIcon } from '@icons';
import { TmdxAffiliateGroundLeg, TxCenterProviderGroundLeg } from '@/api/apis/route';
import { GroundNotFeasibleWarning } from './GroundNotFeasibleWarning';

type GroundProviderLegInfoType = {
  leg: TmdxAffiliateGroundLeg | TxCenterProviderGroundLeg;
};

const checkGroundMetadata = (leg: TmdxAffiliateGroundLeg | TxCenterProviderGroundLeg) => {
  return leg.driver && (leg.phoneNumber || leg.email) && leg.vehicleType && leg.plateNumber && leg.reservationNumber;
};

export const GroundProviderLegInfo = ({ leg }: GroundProviderLegInfoType) => {
  const hasData = checkGroundMetadata(leg);

  if (hasData && leg.isFeasibleForDrive) return null;

  return (
    <div className="flex flex-col gap-1">
      {!hasData && (
        <div className="w-max flex px-1 py-0.5 rounded-sm gap-1 bg-base-70">
          <div className="text-danger-30">
            <MdOutlineError size={16} />
          </div>
          <CarGroundIcon />
          <span className="text-s-r text-base-10">Data is missing</span>
        </div>
      )}
      {!leg.isFeasibleForDrive && <GroundNotFeasibleWarning />}
    </div>
  );
};
